import {
  FileDownloadOutlined,
  FileUploadOutlined,
  Logout,
  SettingsOutlined,
} from "@mui/icons-material";
import { Menu, MenuItem } from "@mui/material";
import type { PimoReactComponent } from "@pimo/pimo-app-builder";
import {
  DefaultOverlay,
  DefaultOverlayEventNames,
  type DefaultOverlayEventPayload,
  type DefaultOverlayProps,
} from "@pimo/pimo-components";
import { Currency, OperatingEntity, Profile } from "aint-types";
import React from "react";

import { STRAPI_URL } from "../../app/env";

export type InOverlayProps = DefaultOverlayProps & {
  operatingEntities?: OperatingEntity[];
  userProfile?: Profile;
  currency?: Currency;
};

export type InOverlayEventNames =
  | DefaultOverlayEventNames
  | "overlay:download-report"
  | "overlay:download-excel"
  | "overlay:settings-click"
  | "overlay:upload-fx-rates";

export type InOverlayEventPayload =
  | Record<string, never>
  | DefaultOverlayEventPayload;

export const InOverlay: PimoReactComponent<
  InOverlayProps,
  InOverlayEventNames,
  InOverlayEventPayload
> = ({ fireEvent, ...props }) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClose = (
    _: React.MouseEvent<HTMLLIElement, MouseEvent> | object,
    option?: "includeDraft" | "excludeDraft"
  ) => {
    if (option === "includeDraft") {
      window.open(
        [STRAPI_URL, "api/export", "includeDraft", "EUR"]
          .filter(Boolean)
          .join("/")
      );
    } else if (option === "excludeDraft") {
      window.open(
        [STRAPI_URL, "api/export", "excludeDraft", "EUR"]
          .filter(Boolean)
          .join("/")
      );
    }
    setAnchorEl(null);
  };

  const headerProps: InOverlayProps["header"] = {
    ...props.header,
    entries: [
      ...(props?.userProfile?.role === "admin"
        ? [
            {
              text: "Settings",
              icon: SettingsOutlined,
              onClick: () => fireEvent?.("overlay:settings-click"),
            },
          ]
        : []),
      ...(props?.userProfile?.role === "admin" ||
      props?.userProfile?.role === "globalViewer"
        ? [
            {
              text: "Download Data",
              icon: FileDownloadOutlined,
              onClick: (event: React.MouseEvent<HTMLElement>) => {
                props?.userProfile?.role === "admin"
                  ? setAnchorEl(event.currentTarget)
                  : window.open(
                      [STRAPI_URL, "api/export", "excludeDraft", "EUR"]
                        .filter(Boolean)
                        .join("/")
                    );
              },
            },
          ]
        : []),
      ...(props?.userProfile?.role === "admin" ||
      props?.userProfile?.role === "globalViewer"
        ? [
            {
              text: "Upload FX Rates",
              icon: FileUploadOutlined,
              onClick: () => {
                fireEvent?.("overlay:upload-fx-rates");
              },
            },
          ]
        : []),

      {
        text: "Logout",
        onClick: () => fireEvent?.("overlay:logout"),

        icon: Logout,
      },
    ],
    logo: { big: "allianz.svg", small: "allianz.svg" },
    isLegacy: true,
    username: props.userProfile
      ? `${props.userProfile.name} (${props.userProfile.email})`
      : "",
  };

  return (
    <>
      <DefaultOverlay {...props} fireEvent={fireEvent} header={headerProps} />
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={(e) => {
          handleClose(e, undefined);
        }}
        slotProps={{
          list: {
            "aria-labelledby": "basic-button",
          },
        }}
      >
        <MenuItem onClick={(e) => handleClose(e, "includeDraft")}>
          Include Draft Initiatives
        </MenuItem>
        <MenuItem onClick={(e) => handleClose(e, "excludeDraft")}>
          Exclude Draft Initiatives
        </MenuItem>
      </Menu>
    </>
  );
};
